export default __webpack_public_path__ + "static/media/icon-instagram.7d97118a.svg";